import React, { useState, useEffect, createRoot } from 'react';
import weblogo from '../Images/logo.png';
import Userimg from '../Images/icons8-user-50.png';
import mobileLogo from '../Images/logo2.png'
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import SearchBar from './SearchBar';
import { NavOptions } from '../Data/OptionsAndPaths';
import AccountBtn from './AccountBtn'
import { ToggleDarkMode } from '../assets/js/darkmode';
import { useLocation } from 'react-router-dom';

function Header() {

    // NAVBAR STICKY WHEN USER SCROLL LOGIC:
    useEffect(() => {
        const navbarabove = document.getElementById('nav-top')
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const halfscroll = 100
            const scrollThreshold = 200;

            if (scrollPosition > scrollThreshold) {
                navbarabove.classList.add("scrolled-navbar");
            } else {
                navbarabove.classList.remove("scrolled-navbar");
            }
            if (scrollPosition > halfscroll) {
                navbarabove.classList.add("halfscroll");
            } else {
                navbarabove.classList.remove("halfscroll");
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            // Cleanup the event listener when the component unmounts
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);


    // TOGGLE THE DARK/LIGHT MODE:
    const location = useLocation();
    const [isLeft, setIsLeft] = useState(true);
    useEffect(() => {

        // CHECK THE INITIAL VALUE OF DARKMODE:
        const DarkModeOn = localStorage.getItem('DarkModeOn') === 'true';
        setIsLeft(!DarkModeOn)
        ToggleDarkMode();

    }, [isLeft]);


    const togglePosition = () => {
        const DarkModeOn = localStorage.getItem('DarkModeOn') === 'true';
        setIsLeft(!isLeft);
        if (DarkModeOn) {
            localStorage.setItem('DarkModeOn', 'false');
        } else {
            localStorage.setItem('DarkModeOn', 'true');
        }
    };


    // TOGGLE MENU LOGIC:
    const [isMenuOpen, setMenuOpen] = useState(false);
    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            // Re-enable scrolling when the menu is closed
            document.body.style.overflow = '';
        }
    }, [isMenuOpen])


    return (
        <>
            <header>
                <nav>
                    <div className={`nav-mobile-menu-options ${(isMenuOpen) ? 'open' : ''}`}>
                        <div className="mobile-menu-closebtn">
                            <div className='mobile-parent-login-btn' onClick={toggleMenu}>
                                <AccountBtn id={'mobile-accountbtn'} key={'mobile'} />
                            </div>
                            <i className="fas fa-window-close" onClick={toggleMenu}></i>
                        </div>
                        <div className="mobile-manu-options-a">
                            {NavOptions.map((element, index) => (
                                <Link key={index} to={element.path} className={'mobile-menu-links'} onClick={toggleMenu}>
                                    {element.option}
                                </Link>
                            ))}
                            <Link to={'/cart'} className={'mobile-menu-links'} onClick={toggleMenu}>
                              CART
                            </Link>
                        </div>
                    </div>
                    <div className="nav-above" id='nav-top'>
                        <div className="nav-left">
                            <Link to="/" className="Special-a ">
                                <img src={weblogo} alt="" className="logo" />
                            </Link>
                        </div>
                        <div className="mobile-nav-left">
                        <Link to="/" className="mobile-Special-a">
                                <img src={mobileLogo} alt="" className="logo2" />
                            </Link>
                        </div>
                        <SearchBar />
                        <div className="nav-right">
                            <div className="acc-options">
                                <div id="container" className={`notformobile-icon-btns container ${isLeft ? 'container-left' : 'container-right'}`} onClick={togglePosition}>
                                    <div
                                        id="box"
                                        className={`box ${isLeft ? 'left' : 'right'}`}
                                    ></div>
                                    <p className={`darkmode-text ${isLeft ? 'text-left' : 'text-right'}`}>DARK MODE <br />{isLeft ? 'OFF' : 'ON'}</p>
                                </div>
                                <div className="search-mobile-icon">
                                    <i className="fas fa-search"></i>
                                </div>
                                <div className="menu-mobile-icon" onClick={toggleMenu}>
                                    <i className="fas fa-bars"></i>
                                </div>
                                <Link to="/wishlist" className='notformobile-icon-btns icon-btns'>
                                    <i className="fas fa-heart"></i>
                                </Link>
                                <Link to={'/cart'} className='notformobile-icon-btns icon-btns'>
                                    <i className="fas fa-shopping-cart"></i>
                                </Link>
                            </div>
                            <AccountBtn id={'comp-accountbtn'} key={'computer'} />
                        </div>
                    </div>
                    <div className="nav-bottom">
                        <ul className="nav-ul">
                            {NavOptions.map((element, index) => (
                                <li key={index}>
                                    <Link to={element.path} className={'li-link'}>
                                        {element.option}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </nav>
                {/* <nav className="fake-navbar">
                    
                </nav> */}
            </header>
        </>
    );
}

export default Header;
